import React from 'react';

import UserContainer from '../containers/user-container';

import Tooltip from './tooltip';
import UserAvatar from './user-avatar';
import UserName from './user-name';

import IconDoubleTick from '../icons/icon-double-tick';

const MessageSeenBy = ({ users, currentUserId }) => {
    return (
        <Tooltip tooltip={(
            <div className="message-seen-by">
                Message viewed by:

                <div className="users-list">
                    {
                        users.map(userId => userId !== currentUserId && (
                            <div key={userId} className="item">
                                <UserContainer id={userId}>
                                    <UserAvatar size="xsmall" />
                                </UserContainer>

                                <UserName id={userId} />
                            </div>
                        ))
                    }
                </div>
            </div>
        )}>
            <div>
                <IconDoubleTick color="#009084" size="15px" />
            </div>
        </Tooltip>
    )
}

export default MessageSeenBy;
